export const ImageUrl = {
  ADDEMPLOYEE: require("../Assets/NewImage/Dumy.png"),
  CALENDER: require("../Assets/NewImage/calender.png"),
  CAKE: require("../Assets/NewImage/cake.png"),
  CALENDER1: require("../Assets/NewImage/calender1.png"),
  LATE: require("../Assets/NewImage/late.png"),
  MILESTONE: require("../Assets/NewImage/milestone.png"),
  NODATA: require("../Assets/NewImage/nodata.png"),
  NOLEAVE: require("../Assets/NewImage/noleave.png"),
  WATCH: require("../Assets/NewImage/watch.png"),
  EMPLOYEE: require("../Assets/NewImage/totalemployee.png"),
  ATTENDANCE: require("../Assets/NewImage/Attendance.png"),
};
